import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import { useAuth } from '../../../hooks/common/useAuth';
import { setSidebarManItem } from '../../../lib/utils/commonUtils';
import { ADMIN_LEVEL_TYPE } from '../../account/admin/common/constants';

import './SidebarItem.scss';

const SidebarItem = (props) => {
  const { user, can } = useAuth();
  const { id, icon, isCollapsed, onClick, path, text, subMenu = [], active, currentPath } = props;

  const isMasterAccount = user?.level === ADMIN_LEVEL_TYPE.MASTER;
  const canRenderItem = (item) => {
    if (item.shouldMasterLevel) {
      return isMasterAccount;
    }
    if (!item.permissions) {
      return true;
    }
    const { subject, actions } = item.permissions;

    return actions.every((action) => can(action, subject) === true);
  };

  const canRender = id === 'home' || subMenu?.some(canRenderItem);

  if (!canRender) {
    return null;
  }

  const renderSubMenuItems = subMenu?.filter(canRenderItem).map((item, index) => (
    <li key={index} className={cx('sub-menu-item', { active: currentPath === item.path })}>
      <Link to={item.path}>
        <div className="text">{item.text}</div>
      </Link>
    </li>
  ));

  return (
    <section className={cx('sidebar-item', { active }, { 'is-collapsed': isCollapsed })} onClick={() => onClick()}>
      {setSidebarManItem(path, icon, text)}
      {(active || isCollapsed) && subMenu && subMenu.length ? <ul className="sub-menu">{renderSubMenuItems}</ul> : null}
    </section>
  );
};

export default memo(SidebarItem);
